import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { ExpandButtonComponent } from '../expand-button/expand-button.component';
import { LanguageStore } from '../../../shared/services/language.store';
import { ACS_WARRANTY_TABLE_LINK_EN, ACS_WARRANTY_TABLE_LINK_FR } from '../../../shared/helpers/constants';

@Component({
  selector: 'acs-guarantees-table',
  imports: [TranslatePipe, ExpandButtonComponent],
  templateUrl: './guarantees-table.component.html',
  styleUrl: `./guarantees-table.component.scss`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GuaranteesTableComponent {
  expanded: boolean = false;

  #languageStore = inject(LanguageStore);
  get guaranteesTableLink() {
    return this.#languageStore.currentLanguageCode() === 'fr'
      ? ACS_WARRANTY_TABLE_LINK_FR
      : ACS_WARRANTY_TABLE_LINK_EN;
  }

  onExpandClick() {
    this.expanded = !this.expanded;
  }
}
